export default __webpack_public_path__ + "static/media/eisvogel.ded62a6e.jpg";